import { FC } from 'react';
import classNames from 'classnames';

import { NumberSignEnum } from '../../../../lib/enums';
import TradePriceCache from '../../../../lib/store-util/TradePriceCache';
import { getPriceColorByDirection } from '../../../../lib/util/ChartingHelpers';
import { formatCurrencyBySymbol } from '../../../../lib/util/DataHelpers';
import { INVALID_VALUE } from '../../../../lib/util/types';

import { EpicMoversRow } from '../../EpicMovers.types';

import styles from '../../EpicMovers.module.scss';

const LOADING_PRICE_WIDTH = 40;
const LOADING_CHANGE_WIDTH = 50;

type Props = { isReduction: boolean, item: EpicMoversRow, isLoading: boolean };

const PriceAndChange: FC<Props> = (props: Props): JSX.Element => {
  const { item, isReduction, isLoading } = props;
  const { lookupSymbol, currencySymbol, isEuropeanSymbol } = item;
  const { currentPrice, changePercent, direction } = TradePriceCache.use(lookupSymbol, 'SymbolTradeInfoCard');

  if (!item.price) {
    return <>{INVALID_VALUE}</>;
  }
  const color = getPriceColorByDirection(direction);

  return (
    <div className={styles.priceAndChangeContainer}>
      {isLoading ? (
        <>
          <div
            className={classNames(styles.loadingComponent, styles.loadingComponentMargin)}
            style={{ width: LOADING_PRICE_WIDTH }}
          />
          <div className={styles.loadingComponent} style={{ width: LOADING_CHANGE_WIDTH }} />
        </>
      ) : (
        <>
          <span className={GlobalClassesEnum.CommonBody1Text}>
            {formatCurrencyBySymbol(currentPrice ?? item.price, currencySymbol, { isEuropeanSymbol })}
          </span>
          {
            currentPrice && (
              <span style={{ color }}>
                (
                {direction}
                {changePercent}
                )
              </span>
            )
          }
          {
            !currentPrice && (
              <span className={classNames(
                GlobalClassesEnum.CommonBody1Text,
                isReduction ? styles.negative : styles.positive
              )}>
                (
                {!isReduction && NumberSignEnum.Positive}
                {item.changePercentage}
                )
              </span>
            )
          }
        </>
      )}
    </div>
  );
};

export default PriceAndChange;
